/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { createContext, useEffect, useState } from 'react';
import { arrayOf, bool, func, shape, string, oneOf } from 'prop-types';
import { intlShape, injectIntl } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import config from '../../config';
import { LISTING_STATE_PENDING_APPROVAL, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
    LISTING_PAGE_DRAFT_VARIANT,
    LISTING_PAGE_PENDING_APPROVAL_VARIANT,
    LISTING_PAGE_PARAM_TYPE_DRAFT,
    LISTING_PAGE_PARAM_TYPE_EDIT,
    LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT,
    BOOSTING_CH,
    BOOSTING_DE,
} from '../../components/EditListingWizard/config';
import {
    createSlug,
    findDisciplinePathName,
    resolveActivitiesSlug,
    parse,
} from '../../util/urlHelpers';
import { capitalize, trimDisplayNameLastWord } from '../../util/text';
import {
    ensureListing,
    ensureOwnListing,
    ensureUser,
    userDisplayNameAsString,
    ensureCurrentUser,
} from '../../util/data';
import { richText } from '../../util/richText';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import {
    Page,
    NamedRedirect,
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    EmailConfirmationBar,
    LowBalanceNotificationBar,
    LayoutWrapperFooter,
    Footer,
    ReportProfile,
    BurgerMenu,
    StatisticsSection,
    MatchingRateSection,
    LazySection,
    Breadcrumb,
} from '../../components';
import { TopbarContainer } from '../../containers';
import { loadData, setInitialValues } from './ListingPage.duck';
import SectionImages from './Sections/SectionImages/SectionImages.js';
import ActionBarMaybe from './components/ActionBarMaybe.js';
import css from './ListingPage.css';
import DirectionsMaybe from './components/DirectionsMaybe.js';
import TopInfoMaybe from './components/TopInfoMaybe';
import SharingViaSocialNetworkModal from './components/SharingViaSocialNetworkModal.js';
import useBestMatchingListing from '../../hooks/useBestMatchingListing.js';
import { selectOwnRiderListings } from '../../ducks/riderListings.duck';
import { useConfetti } from '../../hooks/useConfetti';
import { useIsMobile } from '../../hooks/useIsMobile.js';
import {
    DEFAULT_LISTING_TITLE,
    RIDER_AVAILABILITY_NOT_AVAILABLE,
} from '../../marketplace-custom-config.js';
import { setLastSeenListings } from '../../util/localStorage.js';
import commmonCss from './Sections/common.css';
import {
    SectionPricing,
    SectionSkills,
    SectionAvailability,
    SectionActivities,
    SectionStable,
    SectionAbout,
    SectionLocation,
    SectionQualifications,
    SectionDisciplines,
    SectionContact,
    SectionMinimumAge,
    SectionMaxWeight,
    ListingCardsCarouselSection,
} from './Sections/index.js';
import {
    anonymizeUser,
    checkIfListingIsAnonymous,
    deanonymizeListing,
    shouldListingBeDeanonymizedForUser,
} from '../../util/anonym';
import ConfirmationModal from './components/ConfirmationModal';
import { useIsMounted } from '../../hooks/useIsMounted';
import { useTrackListingPage } from './hooks/useTrackListingPage.js';
import ListingClosedOverlay from './components/ListingClosedOverlay.js';
import { useCurrentEntityLocation } from '../../hooks/useCurrentEntityLocation.js';
import { getOriginString } from './Sections/ListingCardsCarouselSection/ListingCardsCarouselSection.helpers.js';
import { useUpdateUserVisitors } from './hooks/useUpdateUserVisitors.js';
import { useConfirmationPage } from './hooks/useConfirmationPage.js';
import { listingImages, noIndexTag } from './ListingPage.helpers.js';
import { useSeoBreed } from './hooks/useSeoBreed.js';
import { useMalformedSlug } from './hooks/useMalformedSlug.js';
import PageStateLoading from './pageStates/PageStateLoading.js';
import PageStateNotFound from './pageStates/PageStateNotFound.js';
import PageStateError from './pageStates/PageStateError.js';
import { TopbarContext } from '../../components/Topbar/Topbar.js';
import { SectionInquiry } from './Sections/SectionInquiry/SectionInquiry.js';
import { createResourceLocatorString } from '../../util/routes.js';
import routeConfiguration from '../../routeConfiguration.js';
import StatisticsSectionPackagesInfo from '../../components/StatisticsSection/StatisticsSectionPackagesInfo.js';
import { getSeoBreadcrumbsPaths } from '../../util/seo';
import { selectLocation, selectLocationRequestInProgress } from '../../ducks/locations.duck';

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID } = sdkTypes;
const { userTypeHorseowner, userTypeRider, minMatchingRate, listingTypeHorse } = config;

const windowDefined = typeof window !== 'undefined';

const countryBoostingConfig = {
    CH: BOOSTING_CH,
    DE: BOOSTING_DE,
};

export const ListingPageContext = createContext(undefined);

const ListingPageComponent = ({
    currentUser,
    getListing,
    getOwnListing,
    listingAuthor,
    showListingLoading,
    scrollingDisabled,
    showListingError,
    searchPageListings,
    onDiscardingData,
    intl,
    history,
    params,
    location,
}) => {
    const [isMobile, , computing, viewport] = useIsMobile(1024);
    const [imageCarouselOpen, setImageCarouselOpen] = useState();
    const [isSocialNetworkModalOpen, setIsSocialNetworkModalOpen] = useState();
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [inquiryModalOpen, setInquiryModalOpen] = useState();

    const appIsMounted = useIsMounted();

    const commonPageStatesProps = {
        intl,
        scrollingDisabled,
        noIndexTag,
        appIsMounted,
    };

    const { id } = params;
    const {
        userType,
        availabilityStatus: currentUserAvailability,
        userLocation: currentUserLocation,
        country,
    } = currentUser?.attributes?.profile?.publicData || {};

    const listingId = new UUID(id);
    const authorId =
        !showListingLoading && listingAuthor && listingAuthor.id
            ? listingAuthor.id.uuid
            : undefined;
    const currentUserId = currentUser?.id?.uuid;
    const currentUserIsRider = userType === userTypeRider;
    const currentUserIsHorseowner = userType === userTypeHorseowner;
    const currentUserIsNotAvailable = currentUserAvailability === RIDER_AVAILABILITY_NOT_AVAILABLE;
    const isOwnerView = currentUserId && currentUserId === authorId;
    const isOwnListing = Boolean(currentUserId && authorId && authorId === currentUserId);
    const isPendingApprovalVariant = params.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
    const isDraftVariant = params.variant === LISTING_PAGE_DRAFT_VARIANT;
    const ensuredListing =
        isPendingApprovalVariant || isDraftVariant
            ? ensureOwnListing(getOwnListing(listingId))
            : ensureListing(getListing(listingId));

    const currentListing = /* isOwnListing || */ shouldListingBeDeanonymizedForUser(
        ensuredListing,
        currentUser
    )
        ? deanonymizeListing(ensuredListing)
        : ensuredListing;

    const isAnonymousListing = checkIfListingIsAnonymous(currentListing);
    const ensuredAuthor = isAnonymousListing
        ? anonymizeUser(ensureUser(listingAuthor))
        : ensureUser(listingAuthor);
    const { state: prevPageHistoryState } = location || {};
    const { from: prevPageHistoryInfo } = prevPageHistoryState || {};
    const searchParams = parse(location.search);

    const showNearbyListingsSection = !isOwnListing && !isPendingApprovalVariant && !isDraftVariant;
    /** Logged out case */
    const listingLocationConfig = {
        location: currentListing?.attributes?.geolocation,
        allowed: showNearbyListingsSection && Boolean(listingId),
    };
    /** Logged in case */
    const currentUserLocationConfig = {
        location: currentUserLocation,
        allowed:
            showNearbyListingsSection &&
            !currentUserIsNotAvailable &&
            !currentUserIsHorseowner &&
            Boolean(currentUserId),
    };

    const entityLocationConfig = currentUserLocationConfig.allowed
        ? currentUserLocationConfig
        : listingLocationConfig;

    const entityLocationData = useCurrentEntityLocation(entityLocationConfig);
    const pageOriginStr = getOriginString(entityLocationData);

    const { description = '', title = '', publicData } = currentListing.attributes;

    const {
        publicAddress = '',
        breed: pbBreed = '',
        gender = '',
        starredDisciplines,
        activities,
        userRepresentationId,
        updatedAt,
        addressDetails = { postalCode: '', location: '' },
        mainListingImage,
    } = publicData;

    const [confirmationModalOpen, setConfirmationModalOpen] = useConfirmationPage({ searchParams });
    const [breed] = useSeoBreed({ pbBreed });

    const listingCountryCode = publicData.country || addressDetails?.country;
    const listingLocation = useSelector(state =>
        selectLocation(state, listingCountryCode, addressDetails?.postalCode)
    );
    const listingLocationLoading = useSelector(state =>
        selectLocationRequestInProgress(state, listingCountryCode, addressDetails?.postalCode)
    );

    const listingBreadcrumbsPaths = getSeoBreadcrumbsPaths({
        countryCode: listingCountryCode,
        activities,
        title,
        location: listingLocation,
    });

    const listingState = currentListing?.attributes?.state;
    const listingClosed = listingState === 'closed';

    const listingIsPublished =
        listingState && !listingClosed && !isPendingApprovalVariant && !isDraftVariant;

    /**
     * isOwnListing - owner looks on its own listing
     * !currentUserIsRider - other owner looks on a listing
     */
    const riderListingAuthorId = isOwnListing || !currentUserIsRider ? null : currentUserId;

    /**
     * the current user's own rider listing, used below for matching - fetched
     * once per session by middlewares/currentUser.js, read here rather than
     * re-fetched (see riderListings.duck.js:selectOwnRiderListings)
     */
    const riderListingReadAllowed = Boolean(
        riderListingAuthorId && currentUserIsRider && listingIsPublished
    );
    const [riderListings, riderListingsRequestInProgress] = useSelector(state =>
        selectOwnRiderListings(state, riderListingReadAllowed ? riderListingAuthorId : null)
    );

    const riderListing = Array.isArray(riderListings)
        ? riderListings.find(
              ({
                  attributes: {
                      publicData: { userRepresentationId },
                  },
              }) => !!userRepresentationId
          )
        : null;
    const [scoreReqInProgress, score] = useBestMatchingListing({
        riderListing,
        ownerId: isOwnListing || !currentUserIsRider ? null : authorId,
        mainHorseId: listingId.uuid,
    });

    useEffect(() => {
        id && setLastSeenListings(id);
    }, [id]);

    useMalformedSlug({
        history,
        params,
        listingId,
        getListing,
    });

    useUpdateUserVisitors({
        riderListing,
        currentUserId,
        isOwnListing,
        currentUserIsRider,
        authorId,
        listingId,
    });

    useTrackListingPage({
        currentUser,
        score,
        currentListing,
        currentUserOrigin: pageOriginStr,
    });

    useConfetti({
        isAllowed: confirmationModalOpen && isOwnListing,
    });

    const listingIdMalformed = showListingError?.apiErrors?.some(
        s => s.source && s.source.path.includes('id')
    );

    const listingNotFound = showListingError && showListingError.status === 404;
    const listingIsNotAllowed = showListingError && showListingError.status === 403;
    const redirectToNotFoundPage = listingIdMalformed || listingNotFound || listingIsNotAllowed;
    const listingIsDeleted = ensuredListing?.attributes?.deleted;

    if (listingIsDeleted) {
        return <PageStateError {...commonPageStatesProps} />;
    }

    if (showListingLoading) {
        return <PageStateLoading {...commonPageStatesProps} />;
    }

    if (redirectToNotFoundPage || !currentListing.id) {
        return <PageStateNotFound {...commonPageStatesProps} />;
    }

    if (showListingError) {
        return <PageStateError {...commonPageStatesProps} />;
    }

    const listingSlug = params.slug || createSlug(currentListing);

    const listingType = isDraftVariant
        ? LISTING_PAGE_PARAM_TYPE_DRAFT
        : LISTING_PAGE_PARAM_TYPE_EDIT;

    const isApproved =
        currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

    const pendingIsApproved = isPendingApprovalVariant && isApproved;

    // If a /pending-approval URL is shared, the UI requires
    // authentication and attempts to fetch the listing from own
    // listings. This will fail with 403 Forbidden if the author is
    // another user. We use this information to try to fetch the
    // public listing.
    const pendingOtherUsersListing =
        (isPendingApprovalVariant || isDraftVariant) && showListingError?.status === 403;
    const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

    if (shouldShowPublicListingPage) {
        return <NamedRedirect name="ListingPage" params={params} search={location.search} />;
    }

    const isUserListing = !!userRepresentationId;

    if (isUserListing) {
        return (
            <NamedRedirect
                name="ProfilePage"
                params={{ id: userRepresentationId, userType: 'rider' }}
            />
        );
    }

    const richTitle = (
        <span>
            {richText(title == '__title__' ? DEFAULT_LISTING_TITLE : title, {
                longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
                longWordClass: css.longWord,
            })}
        </span>
    );

    const handleViewPhotosClick = (e, index = 0) => {
        // Stop event from bubbling up to prevent image click handler
        // trying to open the carousel as well.
        e.stopPropagation();

        setImageCarouselOpen(true);
        setSelectedImageIndex(index);
    };

    // const extReviews = ensuredAuthor?.attributes?.profile?.publicData?.externalReviews;
    // When user is banned or deleted the listing is also deleted.
    // Because listing can be never showed with banned or deleted user we don't have to provide
    // banned or deleted display names for the function
    const authorDisplayName = trimDisplayNameLastWord(userDisplayNameAsString(ensuredAuthor, ''));

    const listingSeoActivity = capitalize(resolveActivitiesSlug(activities));
    const facebookImages = listingImages('facebook', mainListingImage);
    const twitterImages = listingImages('twitter', mainListingImage);
    const schemaImages = JSON.stringify(facebookImages.map(img => img.url).filter(s => !!s));
    const siteTitle = config.siteTitle;
    const facebookDescription = `${listingSeoActivity} gesucht für ${title} in ${addressDetails.postalCode} ${addressDetails.location}! 🐴💜`;
    const schemaTitle = intl.formatMessage(
        { id: 'ListingPage.schemaTitle' },
        {
            activity: listingSeoActivity,
            address: publicAddress,
            mainDiscipline: capitalize(findDisciplinePathName((starredDisciplines || [])[0])),
            breed,
            gender: capitalize(gender),
            siteTitle,
        }
    );

    const mainContentClasses = classNames(css.mainContent, {
        [css.overlayed]: listingClosed,
        // [css.fullWidth]: isOwnListing,
    });

    const editParams = {
        id: listingId.uuid,
        slug: isDraftVariant ? LISTING_PAGE_PARAM_TYPE_DRAFT : listingSlug,
    };

    const renderReportProfile = rootClass =>
        !isOwnListing && !isDraftVariant ? (
            <ReportProfile
                user={ensuredAuthor}
                actionId="ListingPage.reportProfileAction"
                headerId="ListingPage.reportProfileHeading"
                reportProfileMessageId="ListingPage.reportProfileMessageId"
                rootClassName={classNames(rootClass, css.reportingMobileSection)}
                initialValues={{
                    listingId: listingId.uuid,
                    type: 'horseListing',
                }}
                options={[
                    'spam',
                    'unrealistic-price',
                    'offensive-content',
                    'wrong-information',
                    'default',
                ]}
            />
        ) : null;

    const showDirectionsBar = !computing && searchPageListings && searchPageListings.length > 0;
    const showListingBreadcrumbs =
        (listingBreadcrumbsPaths || listingLocationLoading) && !isOwnListing;
    const commonSectionsProps = {
        publicData,
        isOwnListing,
        editParams,
        scoreData: score,
        isMobile,
        authorDisplayName,
        isLoggedOut: !currentUserId,
        listingPublished: listingIsPublished,
        isDraftVariant,
    };

    const showMobileNav = isMobile && !isPendingApprovalVariant && !isDraftVariant;
    const showStatisticsSection = isOwnListing && !isDraftVariant;
    const showMatchingSection = listingAuthor && !isDraftVariant && !isPendingApprovalVariant;

    return (
        <Page
            title={schemaTitle}
            scrollingDisabled={scrollingDisabled}
            author={authorDisplayName}
            contentType="website"
            description={description}
            facebookImages={facebookImages}
            twitterImages={twitterImages}
            ogDescription={facebookDescription}
            schema={{
                '@context': 'http://schema.org',
                '@type': 'ItemPage',
                description: description,
                name: schemaTitle,
                image: schemaImages,
            }}
        >
            <ListingPageContext.Provider value={{ inquiryModalOpen, setInquiryModalOpen }}>
                <LayoutSingleColumn className={css.pageRoot}>
                    <LayoutWrapperTopbar>
                        <SectionInquiry currentListing={currentListing} />

                        {showMobileNav && (
                            <>
                                <EmailConfirmationBar />
                                <LowBalanceNotificationBar />
                            </>
                        )}

                        {confirmationModalOpen && isOwnListing && (
                            <ConfirmationModal
                                onClose={urlSearchParams => {
                                    if (windowDefined) {
                                        const url = new URL(window.location.href);

                                        (urlSearchParams || []).forEach(usp =>
                                            url.searchParams.delete(usp)
                                        );

                                        window.history.pushState({}, document.title, url);

                                        setConfirmationModalOpen(false);
                                    }
                                }}
                                authorDisplayName={authorDisplayName}
                            />
                        )}
                        {isMobile && !computing && (
                            <TopInfoMaybe
                                richTitle={richTitle}
                                setSocialNetworkModal={setIsSocialNetworkModalOpen}
                                currentListing={currentListing}
                                isAnonymousListing={isAnonymousListing}
                                actionWrapperClassName={css.mobileNavPanel}
                                rootClassName={css.mobileNavPanelRoot}
                                listingAuthor={ensuredAuthor}
                                currentUser={currentUser}
                            >
                                <TopbarContext.Provider
                                    value={{
                                        showNewListingsStatisticsForLoggedOutUser: true,
                                        currentUserGeoData: entityLocationData,
                                    }}
                                >
                                    <BurgerMenu
                                        rootClassName={css.burgerMenu}
                                        showBackButtonIcon={!isOwnListing}
                                    />
                                </TopbarContext.Provider>
                            </TopInfoMaybe>
                        )}

                        {!isMobile && !computing && <TopbarContainer />}
                    </LayoutWrapperTopbar>

                    <LayoutWrapperMain>
                        <div className={css.pageWrapper}>
                            {currentListing.id ? (
                                <ActionBarMaybe
                                    isOwnListing={isOwnListing}
                                    listing={currentListing}
                                    currentUser={currentUser}
                                    clickHandler={e => e.stopPropagation()}
                                    editParams={{
                                        ...editParams,
                                        type: listingType,
                                        tab: prevPageHistoryInfo?.tab || 'overview',
                                    }}
                                />
                            ) : null}
                            <section
                                className={classNames(css.navigationSection, {
                                    [css.ownNavigation]: isOwnListing,
                                })}
                            >
                                {showListingBreadcrumbs && (
                                    <Breadcrumb
                                        loading={listingLocationLoading}
                                        paths={listingBreadcrumbsPaths}
                                        urlPrefix="/landing"
                                        rootClassName={classNames(css.breadcrumbs, {
                                            [css.breadcrumbsWithDirectionBar]: showDirectionsBar,
                                        })}
                                    />
                                )}
                                {showDirectionsBar && (
                                    <DirectionsMaybe
                                        searchPageListings={searchPageListings}
                                        currentListing={currentListing}
                                        onDiscardingData={onDiscardingData}
                                        history={history}
                                    />
                                )}

                                <TopInfoMaybe
                                    richTitle={richTitle}
                                    authorDisplayName={authorDisplayName}
                                    setSocialNetworkModal={setIsSocialNetworkModalOpen}
                                    currentListing={currentListing}
                                    isAnonymousListing={isAnonymousListing}
                                    listingAuthor={ensuredAuthor}
                                    currentUser={currentUser}
                                />
                            </section>

                            <SectionImages
                                title={title}
                                listing={currentListing}
                                selectedImageIndex={selectedImageIndex}
                                imageCarouselOpen={imageCarouselOpen}
                                onImageCarouselClose={() => setImageCarouselOpen(false)}
                                handleViewPhotosClick={handleViewPhotosClick}
                                isMobile={isMobile}
                                isOwnerView={isOwnerView}
                                loading={riderListingsRequestInProgress}
                                riderListing={riderListing}
                            >
                                {isSocialNetworkModalOpen && (
                                    <SharingViaSocialNetworkModal
                                        slug={params.slug}
                                        emailSharingDescription={facebookDescription}
                                        isOpen
                                        onCloseEnquiryModal={() =>
                                            setIsSocialNetworkModalOpen(false)
                                        }
                                        listing={currentListing}
                                    />
                                )}
                            </SectionImages>

                            <section className={css.mainSection}>
                                <SectionContact
                                    listingAuthor={ensuredAuthor}
                                    riderListing={riderListing}
                                    currentListing={currentListing}
                                    isOwnListing={isOwnListing}
                                    isAnonymousListing={isAnonymousListing}
                                    loading={riderListingsRequestInProgress}
                                />

                                <div className={css.contentContainer}>
                                    {/* isOwnerView - the owner keeps full access to his listing */}
                                    {listingClosed && !isOwnerView ? (
                                        <ListingClosedOverlay currentListing={currentListing} />
                                    ) : null}

                                    <div className={mainContentClasses}>
                                        <div className={css.leftSectionWrapper}>
                                            {showMatchingSection && (
                                                <MatchingRateSection
                                                    currentUser={currentUser}
                                                    profileSettingsDescId="ListingPage.profileSettingsDesc"
                                                    signUpLinkDescId="ListingPage.signUpLinkDescId"
                                                    viewProfileRequestModalDescId="ListingPage.viewProfileRequestModalDesc"
                                                    signUpLinkAttributes={{ name: 'SignupRider' }}
                                                    /** force a user to be an owner */
                                                    user={{
                                                        attributes: {
                                                            createdAt:
                                                                ensuredAuthor.attributes.createdAt,
                                                            profile: {
                                                                publicData: {
                                                                    userType: userTypeHorseowner,
                                                                    /**
                                                                     * monitor listing's update info
                                                                     */
                                                                    updatedAt,
                                                                },
                                                            },
                                                        },
                                                    }}
                                                    isLoggedOut={!currentUserId}
                                                    isHorsePage
                                                    isSameUser={isOwnListing}
                                                    currentPageListing={currentListing}
                                                    viewerListing={riderListing}
                                                    scoreReqInProgress={scoreReqInProgress}
                                                    scoreData={score}
                                                    rootClassName={commmonCss.root}
                                                />
                                            )}

                                            {showStatisticsSection && (
                                                <StatisticsSection
                                                    /**
                                                     * `ensuredListing` is passed to handle owner-specific views. It ensures that
                                                     * an owner can always see their horse's activated packages, even when the
                                                     * horse's listing has been deanonymized.
                                                     */
                                                    currentListing={ensuredListing}
                                                    packagesType="listing"
                                                >
                                                    <StatisticsSectionPackagesInfo
                                                        handlePackageActivation={() =>
                                                            history.push(
                                                                createResourceLocatorString(
                                                                    'EditListingPage',
                                                                    routeConfiguration(),
                                                                    {
                                                                        ...editParams,
                                                                        type: LISTING_PAGE_PARAM_TYPE_EDIT_AND_REDIRECT,
                                                                        tab:
                                                                            (country &&
                                                                                countryBoostingConfig[
                                                                                    country
                                                                                ]) ||
                                                                            BOOSTING_CH,
                                                                    },
                                                                    {}
                                                                )
                                                            )
                                                        }
                                                        currentListing={currentListing}
                                                    />
                                                </StatisticsSection>
                                            )}
                                            <SectionMinimumAge {...commonSectionsProps} />
                                            <SectionMaxWeight {...commonSectionsProps} />
                                            <SectionAvailability {...commonSectionsProps} />
                                            <SectionActivities {...commonSectionsProps} />

                                            {renderReportProfile(css.desktop)}
                                        </div>

                                        <div className={css.rightSectionWrapper}>
                                            <SectionAbout
                                                {...commonSectionsProps}
                                                currentListing={currentListing}
                                            />
                                            <SectionDisciplines {...commonSectionsProps} />
                                            <SectionQualifications
                                                {...commonSectionsProps}
                                                currentListing={currentListing}
                                            />
                                            <SectionSkills {...commonSectionsProps} />
                                            <SectionLocation
                                                {...commonSectionsProps}
                                                currentUser={currentUser}
                                                currentListing={currentListing}
                                            />
                                            <SectionStable {...commonSectionsProps} />
                                            <SectionPricing {...commonSectionsProps} />

                                            {renderReportProfile(css.mob)}

                                            {showNearbyListingsSection && (
                                                <LazySection computing={computing}>
                                                    <ListingCardsCarouselSection
                                                        viewport={viewport}
                                                        currentListing={currentListing}
                                                        scoreData={score}
                                                        riderListing={riderListing}
                                                        minMatchingRate={minMatchingRate}
                                                        /**
                                                         * "currentUserIsNotAvailable && currentUserIsRider" condition states
                                                         * that non available rider has not be matched with horses (listings)
                                                         */
                                                        isLoggedIn={
                                                            currentUserIsNotAvailable &&
                                                            currentUserIsRider
                                                                ? false
                                                                : !!currentUserId
                                                        }
                                                        hideButtonsOnEndStart
                                                        params={{
                                                            pub_type: listingTypeHorse,
                                                            origin: pageOriginStr,
                                                        }}
                                                    />
                                                </LazySection>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </LayoutWrapperMain>
                    <LayoutWrapperFooter>
                        <Footer className={css.bottomSeperator} />
                    </LayoutWrapperFooter>
                </LayoutSingleColumn>
            </ListingPageContext.Provider>
        </Page>
    );
};

ListingPageComponent.propTypes = {
    // from withRouter
    history: shape({
        push: func.isRequired,
    }).isRequired,
    location: shape({
        search: string,
    }).isRequired,
    // from injectIntl
    intl: intlShape.isRequired,

    params: shape({
        id: string.isRequired,
        slug: string,
        variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
    }).isRequired,

    isAuthenticated: bool.isRequired,
    currentUser: propTypes.currentUser,
    getListing: func.isRequired,
    getOwnListing: func.isRequired,
    scrollingDisabled: bool.isRequired,
    showListingError: propTypes.error,
    reviews: arrayOf(propTypes.review),
    fetchReviewsError: propTypes.error,
    timeSlots: arrayOf(propTypes.timeSlot),
    fetchTimeSlotsError: propTypes.error,
    sendEnquiryInProgress: bool.isRequired,
};

const mapStateToProps = state => {
    const { isAuthenticated } = state.Auth;
    const { assetsData } = state.Assets;
    const {
        showListingError,
        fetchReviewsError,
        fetchTimeSlotsError,
        reviews = [],
        timeSlots,
        sendEnquiryInProgress,
        similarLocationError,
        listingAuthor,
        showListingLoading,
    } = state.ListingPage;

    const { currentPageResultIds } = state.SearchPage;
    /**
     * listing for back and force navigation, see DirectionsMaybe
     */
    const searchPageListings = getListingsById(state, currentPageResultIds);

    const { currentUser } = state.user;

    const getListing = id => {
        const ref = { id, type: 'listing' };
        const listings = getMarketplaceEntities(state, [ref]);
        return listings.length === 1 ? listings[0] : null;
    };

    const getOwnListing = id => {
        const ref = { id, type: 'ownListing' };
        const listings = getMarketplaceEntities(state, [ref]);
        return listings.length === 1 ? listings[0] : null;
    };

    return {
        isAuthenticated,
        currentUser: ensureCurrentUser(currentUser),
        getListing,
        getOwnListing,
        scrollingDisabled: isScrollingDisabled(state),
        showListingError,
        reviews,
        fetchReviewsError,
        timeSlots,
        fetchTimeSlotsError,
        sendEnquiryInProgress,
        similarLocationError,
        listingAuthor,
        showListingLoading,
        searchPageListings,
        assetsData,
    };
};

const mapDispatchToProps = dispatch => ({
    onDiscardingData: () => dispatch(setInitialValues({})),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    injectIntl
)(ListingPageComponent);

ListingPage.setInitialValues = initialValues => setInitialValues(initialValues);
ListingPage.loadData = loadData;

export default ListingPage;
